import React, { useState } from "react";
import GenericModal from "../../common/modals/GenericModal";
import TitleAndContent from "../../common/modals/TitleAndContent";
import {
  FlexRowBetween,
  GenericDiv,
  MainDiv,
  RespFont,
  ServicesHolder,
} from "../../common/Style";
import { Questions } from "../../unAuth/producers/Style";
import video1 from "../../../assets/client/video1.svg";
import { getImageUrl, GetToast, MenuCss } from "../../common/modals/Toast";
import { editTodos } from "../../../store/reducers/authReducer";
import { useToasts } from "react-toast-notifications";
import expenses1 from "../../../assets/client/expenses.svg";
import brain from "../../../assets/client/brain.svg";
import creditCard from "../../../assets/client/creditCard.svg";
import logout1 from "../../../assets/client/logout.svg";
import editInv from "../../../assets/client/editInv.svg";
import tables from "../../../assets/client/editTables.svg";
import video from "../../../assets/client/video2.svg";
import guests1 from "../../../assets/client/guests.svg";
import todoList from "../../../assets/client/todoList.svg";
import { slide as Menu } from "react-burger-menu";
import { useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import ClientRoutes from "../../../navigation/Routes";
import LogOutAll from "../../common/LogOut/LogOutAll";

const Instruction = () => {
  let history = useHistory();
  const { user } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [isOpen, setIsOpen] = useState(false);
  const [logout, setLogout] = useState(false);

  const setWatchVideo = (index) => {
    let todos = [...user.todos];
    todos[index] = { ...todos[index], done: true };
    dispatch(editTodos({ todos })).then((res) => {
      if (res.payload?.error) GetToast(addToast, "error", res.payload?.error);
    });
  };

  const addGuests = (
    <div>
      <div style={{ fontWeight: "bold", marginBottom: "20px" }}>
        לראות הכל!!!
      </div>
      <div style={{ fontWeight: "bold", marginBottom: "20px" }}>
        לא למחוק אנשים שאינם מגיעים - מאוד חשוב שיהיה לכם את התיעוד הזה בסופו של
        דבר!!!
      </div>
      <a
        target="_blank"
        rel="noreferrer"
        href={"https://youtu.be/CUeyjYHAGX8"}
        style={{ textDecoration: "none" }}
      >
        <GenericDiv
          onClick={() => setWatchVideo(0)}
          background={user.color}
          style={{
            width: "max-content",
            padding: "10px 20px",
            margin: "20px auto",
            marginTop: "10px",
          }}
        >
          <RespFont pSize={"18px"} cSize={"20px"}>
            סרטון
          </RespFont>
          <img src={video1} style={{ width: "30px", marginRight: "20px" }} />
        </GenericDiv>
      </a>
      <div>אם משהו לא מובן או אינכם מצליחים יש לפנות למנהל המערכת</div>
    </div>
  );

  const fixes = (
    <div>
      <a
        target="_blank"
        rel="noreferrer"
        href={"https://youtu.be/w2rKQd--Oro"}
        style={{ textDecoration: "none" }}
      >
        <GenericDiv
          onClick={() => setWatchVideo(0)}
          background={user.color}
          style={{
            width: "max-content",
            padding: "10px 20px",
            margin: "20px auto",
            marginTop: "10px",
          }}
        >
          <RespFont pSize={"18px"} cSize={"20px"}>
            סרטון
          </RespFont>
          <img src={video1} style={{ width: "30px", marginRight: "20px" }} />
        </GenericDiv>
      </a>
      <div>אם משהו לא מובן או אינכם מצליחים יש לפנות למנהל המערכת</div>
    </div>
  );

  const editInvitation = (
    <div>
      <a
        target="_blank"
        rel="noreferrer"
        href={"https://www.youtube.com/watch?v=uI6ELVL5g4s"}
        style={{ textDecoration: "none" }}
      >
        <GenericDiv
          onClick={() => setWatchVideo(1)}
          background={user.color}
          style={{
            width: "max-content",
            padding: "10px 20px",
            margin: "20px auto",
            marginTop: "10px",
          }}
        >
          <RespFont pSize={"18px"} cSize={"20px"}>
            סרטון
          </RespFont>
          <img src={video1} style={{ width: "30px", marginRight: "20px" }} />
        </GenericDiv>
      </a>
      <div style={{ fontWeight: "bold" }}>לא לשכוח לשמור בסוף</div>
      <div>אם משהו לא מובן או אינכם מצליחים יש לפנות למנהל המערכת</div>
    </div>
  );

  const messages = (
    <div>
      <a
        target="_blank"
        rel="noreferrer"
        href={"https://youtu.be/MHCrp7JiZJ0"}
        style={{ textDecoration: "none" }}
      >
        <GenericDiv
          onClick={() => setWatchVideo(2)}
          background={user.color}
          style={{
            width: "max-content",
            padding: "10px 20px",
            margin: "20px auto",
            marginTop: "10px",
          }}
        >
          <RespFont pSize={"18px"} cSize={"20px"}>
            סרטון
          </RespFont>
          <img src={video1} style={{ width: "30px", marginRight: "20px" }} />
        </GenericDiv>
      </a>
      <div>אם משהו לא מובן או אינכם מצליחים יש לפנות למנהל המערכת</div>
    </div>
  );

  const expenses = (
    <div>
      היכנסו לעמוד ההוצאות ובו תוכלו למלא את כל הוצאות החתונה ולסוף את מספר
      המנות, עלות המנה ולהוציא אקסל שיסכום לכם את כל הוצאות החתונה
    </div>
  );

  const gifts = (
    <div>
      <a
        target="_blank"
        rel="noreferrer"
        href={"https://youtu.be/N5KPtxxN1zU"}
        style={{ textDecoration: "none" }}
      >
        <GenericDiv
          background={user.color}
          style={{
            width: "max-content",
            padding: "10px 20px",
            margin: "20px auto",
            marginTop: "10px",
          }}
        >
          <RespFont pSize={"18px"} cSize={"20px"}>
            סרטון
          </RespFont>
          <img src={video1} style={{ width: "30px", marginRight: "20px" }} />
        </GenericDiv>
      </a>
      <div>אם משהו לא מובן או אינכם מצליחים יש לפנות למנהל המערכת</div>{" "}
    </div>
  );

  const arrangementOptions = (
    <div>
      <div>פירוט אופציות ההושבה לפי הסדר:</div>
      <div style={{ textAlign: "right", padding: "0 10px", marginTop: "10px" }}>
        <ul>
          <li>ללא הושבה כלל - האורחים פשוט יושבים היכן שרוצים</li>
          <li>הכוונה באמצעות פתקים ״שמור ____״</li>
          <li>הושבה דיגיטלית בלבד</li>
          <li>
            הושבה דיגיטלית + פתקים ״שמור ____״ כדי לתת מענה למי שלא פתח את
            ההודעות עם מספר השולחן
          </li>
          <li>
            הושבה דיגיטלית + דיילת כדי לתת מענה למי שלא פתח את ההודעות עם מספר
            השולחן
          </li>
          <li>הושבה דיגיטלית עם חלופה לדיילת על מנת לחסוך בעלות השירות</li>
          <li>
            סימון כל אורח שנכנס ומתן פתק עם מספר השולחן שלו באמצעות צוות דיילות
          </li>
        </ul>
      </div>
      <a
        target="_blank"
        rel="noreferrer"
        href={"https://youtu.be/xCx4DpaEsZk"}
        style={{ textDecoration: "none" }}
      >
        <GenericDiv
          background={user.color}
          style={{
            width: "max-content",
            padding: "10px 20px",
            margin: "20px auto",
            marginTop: "10px",
          }}
        >
          <RespFont pSize={"18px"} cSize={"20px"}>
            סרטון
          </RespFont>
          <img src={video1} style={{ width: "30px", marginRight: "20px" }} />
        </GenericDiv>
      </a>
      <div>
        לכל אופציה היתרונות והחסרונות שלה, וכל אירוע וה״ווייב״ שלו, חשוב רק
        להבין את הדברים ורק אז להחליט מה הכי נכון עבורכם 🙏
      </div>
    </div>
  );

  const tablesArrangement = (
    <div>
      <div>מומלץ לשים על מהירות 1.5</div>
      <div>לצפות עד הסוף!</div>
      <a
        target="_blank"
        rel="noreferrer"
        href={
          user.producer === "/itay"
            ? "https://youtu.be/-zJJbBDIXNo"
            : "https://youtu.be/dNoUFu7K6as"
        }
        style={{ textDecoration: "none" }}
      >
        <GenericDiv
          background={user.color}
          style={{
            width: "max-content",
            padding: "10px 20px",
            margin: "20px auto",
            marginTop: "10px",
          }}
        >
          <RespFont pSize={"18px"} cSize={"20px"}>
            סרטון
          </RespFont>
          <img src={video1} style={{ width: "30px", marginRight: "20px" }} />
        </GenericDiv>
      </a>
      <div>עדיף לעבוד מהמחשב</div>
      <div>
        בבקשה שכל צד יושיב את האורחים שלו כדי שבאמת תדעו לשים אנשים שקשורים אחד
        לשני ובכך למנוע מצב בו האורחים לא יקשיבו ויהיה בלאגן
      </div>
    </div>
  );

  const content = [
    // {
    //   q: "הוספת אורחים למערכת",
    //   a: addGuests,
    //   s: { borderRight: "4px solid red" },
    // },
    {
      q: "עריכת הזמנה",
      a: editInvitation,
      s: { borderRight: "4px solid red" },
    },
    // {
    //   q: "שליחת הודעות",
    //   a: messages,
    //   s: { borderRight: "4px solid red" },
    // },
    {
      q: "מילוי הוצאות",
      a: expenses,
      s: { borderRight: "4px solid rgb(0, 255, 187)" },
    },
    {
      q: "מילוי מתנות",
      a: gifts,
      s: { borderRight: "4px solid rgb(0, 110, 255)" },
    },
    {
      q: "אופציות הושבה",
      a: arrangementOptions,
      s: { borderRight: "4px solid red" },
    },
    {
      q: "הושבה במערכת",
      a: tablesArrangement,
      s: { borderRight: "4px solid red" },
    },
    {
      q: "תיקונים",
      a: fixes,
      s: { borderRight: "4px solid red" },
    },
  ];
  const [ans, setAns] = useState(null);
  let fff = content.map((item, index) => {
    return (
      <Questions
        style={{ ...item.s, height: "60px" }}
        key={index}
        onClick={() => setAns(item)}
      >
        {item.q}
      </Questions>
    );
  });
  function addAlpha(color, opacity) {
    const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + _opacity.toString(16).toUpperCase();
  }
  const handleStateChange = (state) => {
    setIsOpen(state.isOpen);
  };

  return (
    <MainDiv
      onClick={() => setIsOpen(false)}
      className="animate__animated animate__fadeIn"
      style={{
        background: `radial-gradient(circle, ${addAlpha(
          user.color,
          0.25
        )} 0%, #f2f2f2 100%)`,
      }}
    >
      <Menu
        noOverlay
        isOpen={isOpen}
        onStateChange={handleStateChange}
        right
        width={"max-content"}
        styles={MenuCss(user.color)}
      >
        <div
          className="menu-item"
          style={{ marginTop: "0px" }}
          onClick={() => history.push(ClientRoutes.User.guests)}
        >
          <div>מוזמנים</div>
          <img src={guests1} style={{ width: "25px" }} />
        </div>
        <div
          className="menu-item"
          onClick={() => history.push(ClientRoutes.User.tables)}
        >
          <div>מערך שולחנות</div>
          <img src={tables} style={{ width: "25px" }} />
        </div>
        <div
          className="menu-item"
          onClick={() => history.push(ClientRoutes.User.instructions)}
        >
          <div>הדרכות</div>
          <img src={video} style={{ width: "25px" }} />
        </div>
        <div
          className="menu-item"
          onClick={() => history.push(ClientRoutes.User.editDetails)}
        >
          <div>עריכת הזמנה</div>
          <img src={editInv} style={{ width: "23px" }} />
        </div>
        <div
          className="menu-item"
          onClick={() => history.push(ClientRoutes.User.todos)}
        >
          <div>יומן משימות</div>
          <img src={todoList} style={{ width: "28px" }} />
        </div>
        <div
          className="menu-item"
          onClick={() => history.push(ClientRoutes.User.expenses)}
        >
          <div>יומן הוצאות</div>
          <img src={expenses1} style={{ width: "25px" }} />
        </div>
        <div
          className="menu-item"
          onClick={() => history.push(ClientRoutes.User.print)}
        >
          <div>מוח המערכת</div>
          <img src={brain} style={{ width: "25px" }} />
        </div>
        <div
          className="menu-item"
          onClick={() => history.push(ClientRoutes.User.payments)}
        >
          <div>העברות באשראי</div>
          <img src={creditCard} style={{ width: "25px" }} />
        </div>
        <div
          className="menu-item"
          style={{
            position: "absolute",
            bottom: "20px",
            fontWeight: "bold",
            fontSize: "20px",
          }}
          onClick={() => setLogout(true)}
        >
          <div>התנתקות</div>
          <img src={logout1} style={{ width: "25px" }} />
        </div>
      </Menu>
      <RespFont
        style={{
          margin: "10px auto",
          fontFamily: "openSansRegular",
          fontWeight: "600",
          textShadow: "2px 2px 2px silver",
        }}
        pSize={"22px"}
        cSize={"30px"}
      >
        הדרכות
      </RespFont>
      <RespFont style={{ width: "90%", margin: "0 auto", textAlign: "center" }}>
        כדי שדברים ייעשו על הצד הטוב ביותר באירוע שלכם - חשוב שתראו את הסרטונים
      </RespFont>
      <RespFont style={{ marginTop: "10px", fontWeight: "bold" }}>
        מומלץ לשים על מהירות 1.5
      </RespFont>
      <FlexRowBetween style={{ width: "90%", margin: "20px auto" }}>
        <GenericDiv
          style={{ width: "30%", padding: "10px 0" }}
          background={"red"}
        >
          חובה
        </GenericDiv>
        <GenericDiv
          style={{ width: "30%", padding: "10px 0" }}
          background={"rgb(0, 110, 255)"}
        >
          מומלץ
        </GenericDiv>
        <GenericDiv
          style={{ width: "30%", padding: "10px 0" }}
          background={"rgb(0, 255, 187)"}
        >
          אופציונאלי
        </GenericDiv>
      </FlexRowBetween>
      <ServicesHolder>{fff}</ServicesHolder>
      {ans && (
        <GenericModal
          init={setAns}
          div={<TitleAndContent title={ans.q} content={ans.a} init={setAns} />}
        />
      )}
      {logout && (
        <GenericModal init={setLogout} div={<LogOutAll init={setLogout} />} />
      )}
    </MainDiv>
  );
};

export default Instruction;
